import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import SiteLauncher from './site-launcher';

function RemoteSiteLauncher() {
    const dispatch = useDispatch();
    const { nodeSelected } = useSelector(state => state.tree);
    const { nodeApplication } = nodeSelected.applicationData;
    const { remoteSiteLauncher } = nodeApplication;

    const onChangeTextValue = prop => (value) => {
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeApplication,
                remoteSiteLauncher: {
                    ...remoteSiteLauncher,
                    [prop]: value
                }
            }
        }
        dispatch(changeNodeGlobalData(newNode));
    }

    return (
        <SiteLauncher
            onChangeTextValue={onChangeTextValue}
            value={remoteSiteLauncher}
        />
    )
}

export default RemoteSiteLauncher;
